/***************/
/*** General ***/
/***************/
export const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8008";
export const SKIP_LICENSING_CHECK =
  import.meta.env.VITE_SKIP_LICENSING_CHECK === "check-with-server"
    ? "check-with-server"
    : import.meta.env.VITE_SKIP_LICENSING_CHECK === "true";
export const SKIP_MAINTENANCE_CHECK = import.meta.env.VITE_SKIP_MAINTENANCE_CHECK === "true";

/******************/
/*** Onboarding ***/
/******************/
export const SKIP_ONBOARDING_STATUS_CHECK =
  import.meta.env.VITE_SKIP_ONBOARDING_STATUS_CHECK === "true";

/******************/
/*** Chat ***/
/******************/
export const CHAT_PATH = "/home";
